import { Component, type ErrorInfo, type ReactNode } from "react";
import { ErrorFallbackPage } from "@/components/ErrorFallbackPage";

type AppErrorBoundaryProps = {
  children: ReactNode;
  /** Defaults to a full navigation to `/` so error state is cleared. */
  onGoHome?: () => void;
};

type State = {
  error: Error | null;
};

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[checkbun] UI error:", error, info.componentStack);
  }

  override render() {
    if (this.state.error) {
      const goHome = this.props.onGoHome ?? (() => window.location.assign("/"));
      return (
        <ErrorFallbackPage
          error={this.state.error}
          onReset={() => this.setState({ error: null })}
          onGoHome={goHome}
        />
      );
    }
    return this.props.children;
  }
}
